import { computed, onBeforeMount, ref } from 'vue'
import FormCheckbox from '../FormCheckbox/FormCheckbox.vue'
import FormInputDropdown from '../FormInputDropdown/FormInputDropdown.vue'
import FormInputTextField from '../FormInputTextField/FormInputTextField.vue'
import FormInputTextarea from '../FormInputTextarea/FormInputTextarea.vue'
import StafetLysPoserList from '../StafetLysPoserList/StafetLysPoserList.vue'
import StafetActions from '../StafetActions/StafetActions.vue'
import _stafetCommonStepsProps from '../../foundation/js/configurations/_stafetCommonStepsProps'
import { useStore } from 'vuex'
import getItemFromStorage from 'foundation/js/sessionStorageWrapper/getItemFromStorage'
import sessionStorageIdentifierEnum from 'foundation/js/sessionStorageWrapper/sessionStorageIdentifierEnum'
import getFieldValue from 'foundation/js/stafet/getFieldValue'
import isBoolean from 'foundation/js/inputValidators/isBoolean'

export default {
    name: 'StafetDonationTaendLysStepTwo',
    components: {
        FormCheckbox,
        FormInputDropdown,
        FormInputTextField,
        FormInputTextarea,
        StafetLysPoserList,
        StafetActions
    },
    props: _stafetCommonStepsProps,
    setup(props) {
        const store = useStore()
        const donationPerLightBag = ref(props.lysposeMinimumAmount)
        const isLysposerDedicated = ref(false)
        const addPersonalNote = ref(false)
        const lysposeSubmissionModels = ref([])
        const lightBagMeta = ref({})

        const donationAmount = computed(() => {
            const userInputs = store.state.donation.userInputs
            const amount = userInputs.find(
                (input) => input.name === 'donationAmount'
            )
            return amount ? amount.value : 0
        })

        onBeforeMount(() => {
            const storedFields = getItemFromStorage(
                sessionStorageIdentifierEnum.STAFET_DONATION
            )

            if (storedFields) {
                if (getFieldValue(storedFields, 'lysposeSubmissionModels')) {
                    lysposeSubmissionModels.value = getFieldValue(
                        storedFields,
                        'lysposeSubmissionModels'
                    )
                }

                if (getFieldValue(storedFields, 'isLysposerDedicated')) {
                    isLysposerDedicated.value = getFieldValue(
                        storedFields,
                        'isLysposerDedicated'
                    )
                }

                if (getFieldValue(storedFields, 'ownTextLysposer')) {
                    addPersonalNote.value = getFieldValue(
                        storedFields,
                        'ownTextLysposer'
                    )
                }
            }
        })

        const StafetFlowLightBagsMetaListLabels = {
            isLysposeDedicatedCheckboxLabel:
                props.labels.taendEtLysCustomizeLysposeBoolDedicatedLabel,
            personalNoteCheckboxLabel:
                props.labels.taendEtLysCustomizeLysposeBoolOwnNoteLabel,
            personalizeLightBagsTitle: props.labels.taendEtLysLysposeTitle,
            lightDedicatedToTextLabel:
                props.labels.taendEtLysLysposeDedicatedToLabel,
            lightDedicatedToErrorMessage:
                props.labels.taendEtLysLysposeDedicatedToErrorMessage,
            lightDedicatedToHelpTextLabel:
                props.labels.taendEtLysLysposeDedicatedToSubtext,
            personalNoteTextLabel:
                props.labels.taendEtLysLysposePersonalNoteLabel,
            personalNoteHelpTextLabel:
                props.labels.taendEtLysLysposePersonalNoteSubtext,
            personalNoteErrorMessage:
                props.labels.taendEtLysLysposePersonalNoteErrorMessage,
            dedicationTypeTextLabel:
                props.labels.taendEtLysLysposeDedicatedTypeLabel,
            dedicationTypePlaceholder:
                props.labels.taendEtLysLysposeDedicatedTypePlaceholder,
            dedicationTypeErrorMessage:
                props.labels.taendEtLysLysposeDedicatedTypeErrorMessage,
            inMemoryOf: props.labels.taendEtLysLysposeDedicatedTypeInMemoryOf,
            inSupportOf: props.labels.taendEtLysLysposeDedicatedTypeInSupportOf
        }

        const stepModel = computed(() => {
            const array = []

            if (donationAmount.value > 0) {
                array.push({
                    name: 'lysposeSubmissionModels',
                    value: lightBagMeta.value.donationItems,
                    isValid: lightBagMeta.value.isValid,
                    validator: () => {
                        return lightBagMeta.value.isValid
                    }
                })

                array.push({
                    name: 'isLysposerDedicated',
                    value: lightBagMeta.value.isLysposerDedicated,
                    isValid: true,
                    validator: isBoolean
                })

                array.push({
                    name: 'ownTextLysposer',
                    value: lightBagMeta.value.addPersonalNote,
                    isValid: true,
                    validator: isBoolean
                })
            }

            return array
        })

        const updateLightBagMeta = (data) => {
            lightBagMeta.value = data
        }

        return {
            donationPerLightBag,
            isLysposerDedicated,
            addPersonalNote,
            lysposeSubmissionModels,
            donationAmount,
            lightBagMeta,
            stepModel,
            StafetFlowLightBagsMetaListLabels,
            updateLightBagMeta
        }
    }
}
